import {
    Main
} from './class/page-home.js';

var APP = new Main();
APP.init();